module.exports = __webpack_public_path__ + "img/7.7e39fb1c.jpg";